import { Message } from 'reconnecting-websocket'
import { socket } from '@/utils/Socket'

export function toWebSocketRequest(serviceName: string, data: any): string {
  console.group('toWebSocketRequest')

  const stringifiedData = JSON.stringify(data)
  console.log(`stringifiedData: ${stringifiedData}`)

  const webSocketRequest = `{"${serviceName}": ${stringifiedData}}`
  console.log(`webSocketRequest: ${webSocketRequest}`)

  console.groupEnd()
  return webSocketRequest
}

export function webSocketSend(message: Message) {
  console.group('webSocketSend')

  console.log(`typeof message: ${typeof message}`)
  console.log('message: ', message)
  socket.send(message)

  console.groupEnd()
}

//
